export const defaultValidationError = 'バリデーションエラーです'
// 2189 件数設定
export const flagMaxCount = process.env.REACT_APP_MAX_COUNT != undefined ? process.env.REACT_APP_MAX_COUNT: "100";
// 2326 経由地数上限設定
export const waypointMaxCount = process.env.REACT_APP_WAYPOINT_MAX_COUNT != undefined ? process.env.REACT_APP_WAYPOINT_MAX_COUNT: "30";
// 2326 URL長制限
export const urlMaxLength = process.env.REACT_APP_URL_MAX_LENGTH != undefined ? process.env.REACT_APP_URL_MAX_LENGTH: "60000";

const messages={
    2001: '郵便番号（半角数値）ハイフン付き 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：8文字',
    2002: '日本語とか英語ではない文字があります。',
    2003: '電話番号（半角数値）ハイフン無し 以外の文字が含まれているか、適正ではない桁数の文字が入力されています。最小桁数：10　最大桁数11文字',
    2004: 'メールアドレス 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：2,048文字',
    2005: '口座番号 以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：7〜最大値：7   [VID：bank_no_1]',
    2006: '数値 整数以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：1,000   [VID：time_1]',
    2007: '数値 整数以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：5,000   [VID：distance_1]',
    2008: '正の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：100,000,000   [VID：amt_1]',
    2009: '負の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：-100,000,000.00〜最大値：0   [VID：amt_3]',
    2010: '正の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：100   [VID：num_1]',
    2011: '正の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：1,000   [VID：capacity_qty_1]',
    2012: '日付は現在日時の3カ月前〜現在日時の5年後の範囲内で、存在する日付を入力してください。',
    2013: '日付は現在日時〜現在日時の5年後の範囲内で、存在する日付を入力してください。',
    2014: '日本語 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：255文字',
    2015: '英数字 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：8文字',
    // 2016: 'メールアドレス 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：2048文字',
    2017: '英数字 以外の文字が含まれているか、適正ではない桁数の文字が入力されています。最小桁数：12　最大桁数13文字',
    2018: '日本語 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：1,000文字',
    2019: '日本語 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：255文字',
    2020: '全角カナ 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：255文字',
    2021: '口座名として登録可能な文字 以外が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：255文字',
    2022: '口座番号 以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：7〜最大値：7   [VID：bank_no_1]',
    2023: '不正なファイル形式です。アップロードできるファイルは、pdf、png、gif、jpeg、jpg、bmp 形式のファイルです。',
    2024: '必須項目が未入力です',
    2025: '正の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：0〜最大値：99   [VID：percent_1]',
    2026: '携帯電話番号（半角数値）ハイフン無し 以外の文字が含まれているか、適正ではない桁数の文字が入力されています。最小桁数：11　最大桁数11文字',
    2027: '正の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：-100,000,000.00〜最大値：100,000,000   [VID：amt_2]',
    2028: '正の整数 少数桁0以外の文字が含まれているか、最小値・最大値の範囲を超えています。最小値：1〜最大値：30   [VID：dueday_1]',
    2029: '日本語 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：245文字',
    2030: '日本語 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：20,000文字',
    2031: '英数字 以外の文字が含まれているか、入力可能な文字数を超えています。最小桁数：6　最大桁数8文字',
    2032: '日本語 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：60文字',
    2033: '英数字 以外の文字が含まれているか、入力可能な文字数を超えています。桁数18文字',
    2034: '入力可能な文字数を超えています。入力可能最大文字数：4096文字',
    2035: '適格事業者登録番号は先頭T+13桁半角数字で入力してください。',
    2036: '適格事業者の情報が設定されていません。',
    2037: '利益額が仕入合計の2%に達するまで{amount}円足りません。',
    2038: '電話番号（半角数値）ハイフン無し 以外の文字が含まれているか、適正ではない桁数の文字が入力されています。最小桁数：10　最大桁数10文字',
    2039: '入力可能な文字数を超えています。入力可能最大文字数：1024文字',
    2040: '英数字、「_」アンダースコア 以外の文字が含まれているか、入力可能な文字数を超えています。入力可能最大文字数：80文字',
    2400: `編集中の情報及び経路情報は破棄されます。本当に良いですか？`,
    2401: 'バリデーションエラーです。',
    2402: '登録時にエラーが発生しました。',
    2403: '更新時にエラーが発生しました。',
    2404: 'データがありません。',
    2405: 'アラートがあります。',
    2406: 'PDF生成が失敗しました。',
    2407: '仕入依頼のステータスが全て仕入済ではありません。',
    2408: '請求担当者が設定されていません。',
    2409: 'ステータスが[登録]、[支払依頼済]ではない項目があります。',
    2410: 'ステータスが[仕入依頼済]、[CSV出力済]ではない項目があります。',
    2411: '削除されます。本当に良いですか？',
    2412: '重複する工事番号の工事が存在します。',
    2413: '重複する現場名の工事が存在します。',
    2414: '工事番号が必須の顧客です。',
    2415: '仕入先からの請求書が設定されていません。',
    2416: 'この顧客には選択した方法で案内するための情報が登録されていません',
    2417: '処理を完了しました。',
    2418: '経路図に表示しないとした駐車場が選択されています。',
    2419: '調査CLOSE済みです。',
    2420: "上乗せ額が上乗せ額の上限を超過しています。",
    2421: "元請情報を選択してください",
    2422: "現場の緯度・経度が設定されていません",
    // 2423: "上乗せ上限額を超えています",
    2424: "実費専用の項目に値が入っています。登録する場合はエラーを無視するにチェックしてください",
    2425: "終了月に日割があります",
    2426: "月初から月末の期間です。通し有にしてください",
    2427: "通しルールに適していません",
    2428: '通し番号が不正です',
    // 2428: "東京セキスイ専用の項目ですが間違い無いですか",
    2429: "顧客支店マスタに設定した「上乗せ額の上限」を超過しています",
    2430: "利益額がマイナスです",
    2431: "利用終了日は、利用開始日より大きい日付を入力してください",
    2432: "仕入先情報を選択してください",
    2433: "顧客支店請求書送付先が設定されていません。",
    2434: "区画図登録をしてください。",
    2435: "現場からの半径をいれてください",
    2436: "見積作成には数分要します。お待ちください。",
    2437: "ステータスが[未処理]ではない項目があります。",
    2438: "今日請求済のデータはありません。",
    2439: "ステータスが[請求依頼済]、[請求書生成済]ではない項目があります。",
    2440: "チェックした請求書の締日を入力してください。",
    2441: "元請と下請の顧客が同じです。",
    2442: "経路図なしの駐車場がチェックされています",
    2443: "見積送付済みです",
    2444: "仕入値+敷金+調整額は0円以上になるようにしてください",
    2445: "追加しようとした見積に土地の地番が登録されていません",
    2446: "仕入依頼済です",
    2447: "以下の仕入依頼はcsvが出力されませんが、csvを出力しますか",
    2448: "以下の仕入依頼は仕入済にできませんが、実行しますか",
    2449: "銀行口座情報が登録されていません",
    2450: "以下の見積は請求処理待ちにできませんが、実行しますか",
    2451: "以下の見積は請求済にできませんが、実行しますか",
    2452: "請求担当者を設定してください",
    2453: "請求書送付先住所が設定されてません",
    2454: "口座情報が設定されてません",
    2455: "ステータスが[空有]、[満車（空予定）]ではない項目があります。",
    2456: "請求担当者が設定されてない見積があります",
    2457: "口座情報が設定されてない見積があります",
    2458: "請求書送付先住所が設定されてない見積があります",
    2459: "経路図表示なしの駐車場、あるいは調査状況が空有・満車（空予定）以外の駐車場が選択されています",
    2460: "仕入金額＋仕入の追金＋敷金＋敷金の追金は0円以上になるようにしてください",
    2461: "見積期間：終了日は、見積期間：開始日より大きい日付を入力してください",
    2462: "契約終了日は、契約開始日より大きい日付を入力してください",
    2463: "から見積作成中です。調査開始してよろしいですか。<br/>調査開始すると見積作成中のものはエラーで作成できなくなります。",
    2464: "残額が0円ではありません。回収済にしますか？",
    2465: "見積作成中です。",
    2466: "住所検索結果取得ができません。住所の確認後、再度検索してください。",
    2467: "以下の見積は請求書生成に失敗しました。",
    2468: "見積登録は15件までできます。",
    2469: "送信予約しました（自動的に送信します）",
    2470: "送信予約に失敗しました",
    2471: "メールが下書きに入るまでに時間がかかる場合があります",
    2472: "仕入対象見積は13件以上追加できません",
    2473: "<span style='color:red'>キャンセル扱いとなります。本当に良いですか？</span>",
    2474: "確定見積書作成に失敗しました",
    2475: "駐車場区画図面作成に失敗しました",
    2476: "区画図登録・更新に失敗しました",
    2477: "ルートが見つかりませんでした。駐車場位置を再調整してください。",
    2478: "ファイル選択してください",
    2479: "引き当て設定対象を選択してください",
    2480: "引き当て残高があります",
    2481: "引き当て可能な金額を超えた請求データがあります",
    2482: "回収済の場合は回収済日付を入力してください",
    2483: "残額が0円ではない請求データあります。回収済にしますか？",
    2484: "引当合計が入金金額を超えています",
    2485: "入金金額がマイナスのため引き当て設定できません",
    2486: "確定後は変更できません",
    2487: "CSVファイルを選択してください",
    2488: "入金履歴が10件を超える請求データがあります。",
    2489: "見積を選択してください。",
    2490: "アップロードできないファイルです。",
    2491: "コピーされた依頼です。<br/>再見積した場合は、「再見積」ボタンをクリックしてください。<br/>駐車場を選び直したい場合は、このままお進みください。",
    2492: "顧客システム利用終了日は、顧客システム利用開始日より大きい日付を入力してください",
    2493: "未作成の見積があります。",
    2494: "一覧請求の請求支店が設定されてない見積があります",
    2495: "一覧請求の請求支店に請求先情報が設定されてない見積があります",
    2496: "顧客区分設定の場合、請求担当デフォルト設定＞都度請求担当者設定は選択できません",
    2497: "一部入金、入金済の見積はキャンセル申請できません。",
    2498: '重複する会社ログインIDが存在します。',
    2499: '会社ログインIDは空にはできません。',
    2500: 'お問合せ画面へも反映する場合はコメントを入力してください。',
    2501: 'すでに登録済みの顧客です。',
    2502: '空台数が０台の駐車場があります。',
    2503: '経路図作成に失敗しました。画面をリロードします。',
    2504: 'システム管理者はメールアドレスが必須です。',
    2505: '重複する会社IDが存在します。',
    2506: '重複する支店IDが存在します。',
    2507: '更新が完了しました。',
    2508: '経路図作成に失敗しました。',
    2509: 'ステータスが[空有]、[満車（空予定）]以外では見積登録候補に登録することはできません。',
    2510: '見積登録候補に1件以上登録してください。',
    2511: '16件以上は見積登録候補に登録することはできません。',
    2512: '見積駐車場候補から除外されますがよろしいですか？',
    2513: '空台数は0台では見積登録候補に登録することはできません。',
    2514: '[経路図に表示しない]では見積登録候補に登録することはできません。',
    2515: '調査担当者または契約担当者を設定してください。',
    2517: '返答BOXに送付しますがよろしいですか?',
    2518: '選択した依頼に調査担当者ロックされている依頼が含まれているため、登録することはできません。',
    2519: '調査状況[保留]の際はコンタクトメモを入力してください。',
    2520: '調査担当者をロックしますがよろしいですか?',
    2521: '調査担当者のロックを解除しますがよろしいですか?',
    2522: 'チェックOKに変更しますがよろしいですか?',
    2523: 'チェックNGに変更しますがよろしいですか?',
    2524: 'チェックされた案件がありません。チェックをオンにして実行してください。',
    2525: '変更する調査担当者が選択されていません。担当者を選択して実行してください。',
    2526: '案件の調査担当者を変更しますがよろしいですか?',
    2527: '更新が完了しました。',
    2528: '更新が完了しました。',
    2529: '特別承認を実行しますがよろしいですか？',
    2530: "見積作成済みです",
    2531: "選択した案件に発注担当者ロックされている案件が含まれているため、変更することはできません。",
    2532: '変更する発注担当者が選択されていません。担当者を選択して実行してください。',
    2533: '案件の発注担当者を変更しますがよろしいですか?',
    2534: "選択した案件に仕入担当者ロックされている案件が含まれているため、変更することはできません。",
    2535: '変更する仕入担当者が選択されていません。担当者を選択して実行してください。',
    2536: '案件の仕入担当者を変更しますがよろしいですか?',
    2537: "提出区画図が作成されていません。",
    2538: "受領請求書がアップロードされていません。",
    2539: "支払額を修正してください。",
    2540: "実費専用の項目に値が入っているため、自動承認がNGとなっています。",
    2541: "顧客支店マスタに設定した「上乗せ額の上限」を超過しているため、自動承認がNGとなっています。",
    2542: "利益額がマイナスのため、自動承認がNGとなっています。",
    2543: "メールが送信されるまでに時間がかかる場合があります。",
    2544: "駐車場空台数以下の台数を入力してください。",
    2545: "支払方法が振込の場合、支払口座は必須です。",
    2546: "項目名が入力されていません。",
    2547: "金額が入力させていません。",
    2601: "適格事業者番号を入力してください。",
    2602: "仕入先の適格事業者情報が登録されていないため、選択することはできません。",
    2603: "適格事業者情報を登録してください。",
    2604: 'すでに登録済みのメールアドレスです。',
    2605: "ダブルクォートは入力できません。",
    2606: "10件以下にデータを絞り込んでください。",
    2607: "残額が0円ではないデータがあります。",
    2608: "45文字以内で入力してください",
    2609: "32文字で入力してください",
    2610: "顧客支店マスタ契約書作成：有無が契約書を作成しないのため変更できません",
    2611: "変更後の契約開始日は変更前より大きい日付を設定してください。",
    2612: "変更後の契約終了日は変更前より小さい日付を設定してください。",
    2613: "契約開始日は契約終了日より小さい日付を設定してください。",
    2614: "JESUSから登録した工場情報にはFAXは送信されません",
    2615: "見積対象外かつ経路図に表示するステータスの駐車場が"+flagMaxCount+"件以上の場合、超えた分の駐車場は経路図には表示されません。",
    2616: "締め処理が完了していない日付を設定してください。",
    2617: "回収済みのデータが含まれているため、登録できません",
    2618: "売上が0以下になるため、入力できません",
    2619: "入金が請求額より多くなるため、入力できません",
    2620: "一覧請求の請求支店に口座情報が設定されてない見積があります",
    2621: "一覧請求の請求支店に請求先住所が設定されてない見積があります",
    2622: "一覧請求の請求支店に請求担当者が設定されてない見積があります",
    2623: "経路図画像のURLの文字数が超過している為、経路図が作成できません。作成可能最大文字数："+urlMaxLength+"文字",
    2624: "経由地の追加は"+waypointMaxCount+"箇所までです",
    2625: "受注管理 STATUS_CODE から再作成してください",
    2626: "ANDPAD連携失敗しました、工事詳細画面から[区画図、確定見積書]ファイルをアップロードし直してください",
    2627: "ANDPAD連携失敗しました、工事詳細画面から[区画図]ファイルをアップロードし直してください",
    2628: "ファイルが未連携です",
    2629: "ファイル削除に失敗しました",
    2630: "ANDPAD連携失敗しました、ANDPAD側に連携する案件情報が存在しません",
    2631: "現場担当者の電話番号が無効なためSMS通知に失敗しました",
    2632: "処理中にエラーが発生しました。<br/>下書きに保存されませんでした。<br/>FAXのチェックは外して再度申込書を作成してください。",
    2999: '未知のエラーが発生しました',
}

export const customMessages = {
    "customer_system_use_flag":"※先に支店名と担当者を登録してください。",
    "customer_system_use_flag_branch":"※先に担当者を登録してください。"
}

export function GetMessage(messageNumber){
    return (Array.isArray(messageNumber))
    ? messageNumber.sort((a,b) => (a-b)).map(singleMessageNo=>isNaN(parseInt(singleMessageNo))?singleMessageNo:`[${singleMessageNo}]`+messages[singleMessageNo]).join("<br/>")
    : `[${messageNumber}]`+messages[messageNumber]
}

/**
 * message本文の {param}をvalueに置換したメッセージを返却
 * messageNumberは単一（配列不可）
 * params: {param: value}
 */
export function GetMessageWithParam(messageNumber, params={}){
    let message = messages[messageNumber]
    for(let key in params) {
        message = message.replaceAll('{' + key + '}', params[key])
    }
    return `[${messageNumber}]`+message
}

export function getErrorCodes(errors, ignore_error = 0){
    const messages = Object.keys(errors).reduce((acc,errorKey) => {
        const error = errors[errorKey]
        if(ignore_error == 0 && error){
            acc[error[0]]=true
        } else if(error && (!error[1] || error[1].notIgnore === true)){
            acc[error[0]]=true
        }
        return acc
    }, {})
    return Object.keys(messages)
}
